<template>
  <div class="sub_alfx">
    <div class="sub_search">
      <!--<a class="pic" @click="getSubHomeworkDate"><img src="../../assets/img/search_icon.png" alt=""></a>-->
      <input
        type="text"
        :placeholder="$t('sub_index.search_plc_a')"
        v-model="keyword"
      /><a href="#" @click="getSubHomeworkDate">{{ $t("sub_index.search") }}</a>
    </div>
    <div class="sub_list">
      <div class="sub_list_nav">
        <span :class="{ cur: study_status == 2 }" @click="loadData(2)"
          >{{ $t("sub_index.study_status1") }} <i></i
        ></span>
        <span :class="{ cur: study_status == 3 }" @click="loadData(3)"
          >{{ $t("sub_index.study_status2") }} <i></i
        ></span>
        <span :class="{ cur: study_status == 1 }" @click="loadData(1)"
          >{{ $t("sub_index.study_status3") }} <i></i
        ></span>
        <span :class="{ cur: study_status == 0 }" @click="loadData(0)"
          >{{ $t("sub_index.study_status4") }} <i></i
        ></span>
      </div>
      <div class="sub_list_con">
        <scroll
          class="wrapper"
          :data="subHomeworkData"
          :pulldown="pulldown"
          :pullup="pullup"
          @pulldown="getSubHomeworkDate"
          @scrollToEnd="getSubHomeworkDate('up')"
        >
          <ul class="content">
            <li
              @click="goDetail(item)"
              v-for="(item, index) in subHomeworkData"
              :key="index"
            >
              <img :src="item.avatar ? item.avatar : defaultHeadImg" alt="" />
              <div class="top">
                <h4 class="over-hide">{{ item.username }}</h4>
                <span
                  :class="{
                    pass: item.is_pass == 1,
                    unPass: item.is_pass == 0,
                  }"
                  v-if="item.study_status == 3"
                  >{{ item.score }}{{ $t("sub_index.credits") }}</span
                >
                <span class="unPass" v-if="item.study_status == 1">{{
                  $t("sub_index.study_status3")
                }}</span>
              </div>
              <div class="bottom">
                <span class="tit over-hide">{{ item.resource_name }}</span>
                <span class="time fr">{{ item.created_at }}</span>
              </div>
            </li>
          </ul>
          <div class="loading-no" v-if="subHomeworkData.length == 0">
            <span>{{ $t("sub_report.noContent") }}</span>
          </div>
          <div class="loading-wrapper" v-else v-show="pullupFlag">
            <img
              src="../../assets/img/loading.gif"
              alt=""
              v-show="pullupFlagImg"
            />{{ pullupValue }}
          </div>
        </scroll>
      </div>
    </div>
    <!--提示框-->
    <div class="model model_slide" v-show="showModel">{{ modelValue }}</div>
  </div>
</template>
<script>
import defaultHeadImg from "@/assets/img/new/default.png";
import scroll from "@/components/better_scroll.vue";
export default {
  data() {
    return {
      keyword: "", //搜索关键词
      login_name: "", //登录名
      username: "", //用户名
      resources_name: "", //资源名
      trainplan_name: "", //计划项目名
      subHomeworkData: [], //案例分析数据
      defaultHeadImg: defaultHeadImg,
      showModel: false,
      modelValue: "", //提示框内容
      study_status: 2,
      page: 1,
      subListData: [], //暂存列表数据

      pulldown: true,
      pullup: true,
      pullupFlag: false,
      pullupFlagImg: false,
      pullupValue: this.$t("sub_report.loading"),
    };
  },
  created() {
    this.study_status =
      this.$route.query.study_status >= 0 ? this.$route.query.study_status : 2;
    this.getSubHomeworkDate();
  },
  mounted() {
    this.$nextTick(() => {
      //     this.getSubHomeworkDate();
    });
  },
  components: {
    scroll,
  },
  methods: {
    getSubHomeworkDate(e) {
      if (e == "up") {
        this.pullupFlag = true;
        this.page++;
      } else {
        this.page = 1;
        this.pullupValue = this.$t("sub_report.loading");
      }
      var _this = this;
      let url = "index.php/mobile/homework/my-sub-homework-list";
      let params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage.getItem("_sys_id"),
        language: localStorage.getItem("_user_data_language"),

        page: this.page,
        size: 10,
        study_status: this.study_status,
        keyword: this.keyword,
      };
      this.$axios.post(url, params).then(function (res) {
        if (res.data.code == 0) {
          if (e == "up") {
            if (_this.page <= res.data.result.pages.page_count) {
              _this.subHomeworkData = _this.subListData.concat(
                res.data.result.data
              );
              _this.subListData = _this.subHomeworkData;
            } else {
              _this.pullupFlagImg = false;
              _this.pullupValue = this.$t("sub_report.noMore");
            }
          } else {
            _this.subHomeworkData = res.data.result.data;
            _this.subListData = res.data.result.data;
          }
          // console.log(_this.subHomeworkData);
          // console.log(res);
        } else {
          this.showModel = true;
          this.modelValue = res.data.msg;
          setTimeout(() => {
            this.showModel = false;
          }, 2000);
        }
      });
    },
    loadData(e) {
      this.page = 1;
      this.study_status = e;
      this.getSubHomeworkDate();
    },
    goDetail(e) {
      if (e.study_status != 1) {
        this.$router.push({
          name: "sub_homework_detail",
          query: {
            trainplan_id: e.trainplan_id,
            resources_id: e.resources_id,
            my_sub_id: e.user_id,
            study_status: this.study_status,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sub_alfx {
  height: 100%;
  font-size: 0.22rem;
  background-color: #f6f6f6;
  .sub_search {
    width: 5.4rem;
    height: 0.48rem;
    background: rgba(255, 255, 255, 1);
    /*border:1Px solid rgba(216, 216, 216, 0.85);
       */
    border-radius: 0.04rem;
    margin-bottom: 0.4rem;
    .pic {
      display: inline-block;
      float: left;
      img {
        display: inline-block;
        float: left;
        width: 0.24rem;
        height: 0.24rem;
        margin: 0.12rem 0.18rem;
      }
    }
    input {
      float: left;
      height: 0.48rem;
      width: 4.4rem;
      padding: 0.12rem 0;
      box-sizing: border-box;
      border: 1px solid rgba(216, 216, 216, 0.85);
      text-indent: 0.22rem;
      border-right: none;
      line-height: normal;
      border-radius: 0;
    }
    a {
      display: inline-block;
      height: 0.48rem;
      line-height: 0.48rem;
      width: 1rem;
      background-color: $mColor;
      color: #fff;
      text-align: center;
      border-radius: 0 0.04rem 0.04rem 0;
    }
    @include pl-color(#a9aeaf);
  }
  .sub_list {
    .sub_list_nav {
      margin-left: 0.16rem;
      display: flex;
      span {
        margin-right: 0.48rem;
        color: #a9aeaf;
        position: relative;
        display: inline-block;
        height: 0.42rem;
        white-space: nowrap;
        &.cur {
          color: $mColor;
          i {
            position: absolute;
            bottom: 0;
            left: 50%;
            margin-left: -0.14rem;
            display: inline-block;
            width: 0.28rem;
            height: 0.04rem;
            background-color: $mColor;
          }
        }
      }
    }
    .sub_list_con {
      position: relative;
      .wrapper {
        position: absolute;
        left: 0;
        top: 0.2rem;
        overflow: hidden;
        height: calc(100vh - 2.8rem);
        .loading-wrapper {
          width: 100%;
          text-align: center;
          margin: 0.24rem auto;
          height: 0.4rem;
          background-color: #f6f6f6;
          color: #000;
          padding: 0;
          font-size: 0.22rem;
          img {
            display: inline-block;
            width: 0.3rem;
            height: 0.3rem;
            vertical-align: middle;
            margin-right: 0.2rem;
          }
        }
        .loading-no {
          width: 3.2rem;
          height: 3.2rem;
          margin: 0.2rem auto;
          border-radius: 50%;
          margin-left: 1rem;
          @include bg-image("../../assets/img/scale/sub/no-date");
          -webkit-background-size: 100%;
          background-size: 100%;
          color: #ccc;
          position: relative;
          span {
            font-size: 0.32rem;
            position: absolute;
            bottom: 0.1rem;
            left: 0.92rem;
          }
        }
      }
      ul {
        li {
          width: 5.36rem;
          height: 1.16rem;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(220, 220, 220, 1);
          box-shadow: 0rem 0rem 0.2rem 0rem rgba(0, 0, 0, 0.05);
          border-radius: 0.02rem;
          margin-top: 0.3rem;
          padding: 0.26rem 0.28rem;
          box-sizing: border-box;
          /* &:nth-of-type(10){
                 border:1px solid red;
            }
             &:nth-of-type(20){
                 border:1px solid red;
            }
             */
          img {
            width: 0.66rem;
            height: 0.66rem;
            border-radius: 50%;
            float: left;
            margin-right: 0.16rem;
          }
          .top {
            h4 {
              display: inline-block;
              font-size: 0.2rem;
              color: #252631;
              max-width: 3.2rem;
            }
            span {
              float: right;
              text-align: right;
              font-size: 0.24rem;
              height: 0.28rem;
              margin-top: -0.04rem;
              &.pass {
                color: $passColor;
              }
              &.unPass {
                color: $unPassColor;
              }
            }
            /*margin-bottom: 0.1rem;
               */
          }
          .bottom {
            .tit {
              display: inline-block;
              color: #7f8485;
              font-size: 0.22rem;
              max-width: 2.6rem;
            }
            .time {
              color: #7f8485;
              font-size: 0.16rem;
            }
          }
        }
      }
    }
  }
}
</style>
